import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@eureca/ui';

/**
 * EU-570 — envelope dos campos bloqueados na edição de programa Encerrado /
 * Cancelado. Quando `enabled`, o cursor vira o símbolo de bloqueado e o hover
 * mostra o tooltip "Edição bloqueada" (Figma). Os filhos perdem pointer-events
 * (belt-and-suspenders sobre o `disabled` dos controles — garante que o hover
 * chega no wrapper mesmo sobre inputs disabled, que não disparam mouse events
 * em todos os engines).
 */
export function BlockedEditTooltip({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  if (!enabled) return <>{children}</>;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="cursor-not-allowed [&>*]:pointer-events-none"
            data-testid="program-edit-blocked-field"
          >
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent side="top">Edição bloqueada</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
